import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Radio as MuiRadio } from '@material-ui/core';
import { withDefaultPropsAndStyles } from '../utils';
import { makeStyles } from '../../themes';
export { RadioGroup, useRadioGroup } from '@material-ui/core';
const useStyles = makeStyles(({ palette }) => ({
    inverse: {
        color: ({ color }) => (color === 'secondary' ? palette.secondary.contrastText : palette.primary.contrastText),
        '&.Mui-checked': {
            color: ({ color }) => (color === 'secondary' ? palette.secondary.contrastText : palette.primary.contrastText),
        },
    },
}));
export const Radio = withDefaultPropsAndStyles('Radio', forwardRef(function Radio(_a, ref) {
    var { inverse } = _a, props = __rest(_a, ["inverse"]);
    const classes = useStyles(props);
    return _jsx(MuiRadio, Object.assign({}, props, { className: inverse ? classes.inverse : undefined, ref: ref }), void 0);
}));
//# sourceMappingURL=Radio.js.map